import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-depoimento',
  templateUrl: './sessao-depoimento.component.html',
  styleUrls: ['./sessao-depoimento.component.scss']
})
export class SessaoDepoimentoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
